module.exports = __webpack_public_path__ + "img/image58.c63a283c.png";